module.exports = __webpack_public_path__ + "static/media/card_blue.b6923ede.svg";